import { FormGroup, Label, Input } from "reactstrap";
import { FormattedMessage } from "react-intl";
import TooltipHelp from "../Help/ToolTipHelp";

const PermissionFields = [
  {
    field: "fullAccess",
    label: "FullTeacherAccess",
    tooltip: "ToolTipFullAccessTeacher",
  },
  { field: "purchaser", label: "Purchaser", tooltip: "ToolTipPurchaser" },
];

export default function TeacherPermissionFields({
  values,
  grantor = {},
  onToggle,
}) {
  return (
    <>
      <Label className="form-label mt-3">
        <FormattedMessage id="Permissions" />:
      </Label>
      {PermissionFields.map(({ field, label, tooltip }) => (
        <FormGroup check key={field}>
          <Label check>
            <Input
              type="checkbox"
              checked={values[field]}
              disabled={!grantor[field] && !values[field]}
              onChange={(e) => onToggle(field, e.target.checked)}
            />
            <FormattedMessage id={label} />
          </Label>
          <TooltipHelp
            id={tooltip}
            toolTipText={<FormattedMessage id={tooltip} />}
            placement="right"
          />
        </FormGroup>
      ))}
    </>
  );
}
